import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import AutoComplete from '../../components/AutoComplete';
import { getSketchTechUserProfiles } from '../../actions/sketchTechUserProfilesActions';

export class SetSketchTechDialog extends Component {
    async componentDidMount() {
        await this.getSketchTechnicians();
    }

    getSketchTechnicians = async (searchValue = null) => {
        await this.props.dispatch(getSketchTechUserProfiles(1, searchValue))
    };

    render() {
        const setSketchTechButtonIsDisabled = (!this.props.sketchTech || !this.props.sketchTech.userId);
        return (
            <Dialog open={this.props.open} fullScreen={this.props.fullScreen}>
                <DialogTitle>
                    Choose Sketch Technician Assigned to this Order
                </DialogTitle>
                <DialogContent>
                    <AutoComplete
                        value={this.props.sketchTech}
                        onChange={this.props.onSketchTechChange}
                        labelProp="userName"
                        valueProp="userId"
                        options={this.props.sketchTechUserProfiles}
                        label="Sketch Tech"
                        onSearch={this.getSketchTechnicians}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.props.onDismissClick}
                    >
                        Dismiss
                    </Button>
                    <Button
                        onClick={this.props.onSetSketchTechClick}
                        color="secondary"
                        disabled={setSketchTechButtonIsDisabled}
                    >
                        Set Sketch Tech
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

SetSketchTechDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    open: PropTypes.bool,
    userProfiles: PropTypes.arrayOf(PropTypes.shape({
        userId: PropTypes.number.isRequired,
        userName: PropTypes.string.isRequired
    })),
    sketchTech: PropTypes.shape({
        userId: PropTypes.number,
        userName: PropTypes.string
    }),
    onSketchTechChange: PropTypes.func.isRequired,
    onDismissClick: PropTypes.func.isRequired,
    onSetSketchTechClick: PropTypes.func.isRequired,
};

SetSketchTechDialog.defaultProps = {
    open: false,
};

const mapStateToProps = (state) => {
    const { sketchTechUserProfiles: sketchTechUserProfilesState } = state;
    const {
        sketchTechUserProfiles
    } = sketchTechUserProfilesState;
    return {
        sketchTechUserProfiles
    }
};

export default connect(mapStateToProps)(withMobileDialog()(SetSketchTechDialog));
